import {InputAdornment} from '@mui/material';

export default InputAdornment;
